import { render, staticRenderFns } from "./SetColorAndLogoReminder.vue?vue&type=template&id=1cc40d9e&scoped=true&"
import script from "./SetColorAndLogoReminder.vue?vue&type=script&lang=js&"
export * from "./SetColorAndLogoReminder.vue?vue&type=script&lang=js&"
import style0 from "./SetColorAndLogoReminder.vue?vue&type=style&index=0&id=1cc40d9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc40d9e",
  null
  
)

export default component.exports